import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button"]

  connect() {
    // Aguardar o próximo frame para garantir que o DOM está renderizado
    requestAnimationFrame(() => {
      this.checkOverflow()
    })
  }

  checkOverflow() {
    if (!this.hasContentTarget || !this.hasButtonTarget) return

    const content = this.contentTarget

    // Verificar se o texto está truncado (scrollHeight > clientHeight)
    // Adicionamos uma margem de 2px para evitar falsos positivos
    if (content.scrollHeight > content.clientHeight + 2) {
      this.buttonTarget.classList.remove('hidden')
      this.buttonTarget.classList.add('mt-1')
    } else {
      this.buttonTarget.classList.add('hidden')
      this.buttonTarget.classList.remove('mt-1')
    }
  }

  toggle(event) {
    event.preventDefault()

    const content = this.contentTarget
    const button = this.buttonTarget

    if (content.classList.contains('line-clamp-3')) {
      // Expandir
      content.classList.remove('line-clamp-3')
      button.textContent = 'Ver menos'
    } else {
      // Colapsar
      content.classList.add('line-clamp-3')
      button.textContent = 'Ver mais'
    }
  }
}
